var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2662_58247",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2.96021H2.5V22.9602H22.5V2.96021Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2662_58247)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2662_58247",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.96021H22.5V22.9602H2.5V2.96021Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2662_58247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2738 15.3259L19.8909 12.7363C20.8684 11.7587 22.7483 12.9919 21.7326 14.1869L18.5636 17.9151C18.4395 18.0611 18.297 18.1904 18.1398 18.2999C17.6288 18.6263 17.0204 18.7351 16.421 18.7351H11.7183C11.3781 18.7351 11.0382 18.7548 10.7002 18.7941L9.34769 18.946L6.5423 16.2236C6.5423 16.2236 8.13382 13.2182 11.2556 14.0821C11.8395 14.2437 12.4437 14.3208 13.0496 14.3208H16.1403C17.5953 14.3208 17.6067 16.6326 16.1282 16.6326H13.4375",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50515 22.4863L10.1741 19.7481C10.1748 19.7473 10.1748 19.7461 10.174 19.7454L5.64527 15.3506C5.64452 15.3499 5.64331 15.3499 5.64257 15.3507L2.94855 18.1475L7.50515 22.4863Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8405 16.6161L11.8442 16.6321",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15311 7.18304C5.30706 7.26312 4.64514 7.97554 4.64514 8.84253V10.6175C4.64514 10.9241 4.89366 11.1726 5.20026 11.1726H9.00651C9.31311 11.1726 9.56163 10.9241 9.56163 10.6175V8.84253C9.56163 7.97487 8.89873 7.26206 8.05178 7.18284",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96405 5.57688C8.96405 6.60555 8.13014 7.43945 7.10147 7.43945C6.0728 7.43945 5.23889 6.60555 5.23889 5.57688C5.23889 4.5482 6.0728 3.7143 7.10147 3.7143C8.13014 3.7143 8.96405 4.5482 8.96405 5.57688Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0724 7.18304C10.2264 7.26312 9.56445 7.97554 9.56445 8.84253V10.6175C9.56445 10.9241 9.81297 11.1726 10.1196 11.1726H13.9258C14.2324 11.1726 14.4809 10.9241 14.4809 10.6175V8.84253C14.4809 7.97487 13.818 7.26206 12.9711 7.18284",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8807 5.57688C13.8807 6.60555 13.0468 7.43945 12.0182 7.43945C10.9895 7.43945 10.1556 6.60555 10.1556 5.57688C10.1556 4.5482 10.9895 3.7143 12.0182 3.7143C13.0468 3.7143 13.8807 4.5482 13.8807 5.57688Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9826 7.18304C15.1365 7.26312 14.4746 7.97554 14.4746 8.84253V10.6175C14.4746 10.9241 14.7231 11.1726 15.0297 11.1726H18.836C19.1426 11.1726 19.3911 10.9241 19.3911 10.6175V8.84253C19.3911 7.97487 18.7282 7.26206 17.8812 7.18284",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7974 5.57688C18.7974 6.60555 17.9635 7.43945 16.9348 7.43945C15.9062 7.43945 15.0723 6.60555 15.0723 5.57688C15.0723 4.5482 15.9062 3.7143 16.9348 3.7143C17.9635 3.7143 18.7974 4.5482 18.7974 5.57688Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerManagementIcon);
export default __webpack_public_path__ + "static/media/customer-management-icon.6aac9086cdb20cc1a39fd5750f88ddb6.svg";
export { ForwardRef as ReactComponent };